export type Size = "inline" | "default" | "full";

export type ISizeMap = {
  [key in Size]: string;
};

export const sizeMap: ISizeMap = {
  inline: "w-16",
  default: "w-80",
  full: "w-full",
};

export type LabelGap = 1 | 2 | 3;

export const labelGapMap: Record<LabelGap, string> = {
  1: "gap-1",
  2: "gap-2",
  3: "gap-3",
};
